import {atom} from 'jotai'
// import { atomWithStorage } from 'jotai/utils';

import {
  MemberDetail,
  PackageDetail,
  MemberTab,
  PackagePaymentList,
  PackagePaymentListPaging,
} from '../domain'

export const memberDetailAtom = atom<MemberDetail | null>(null)
export const packageDetailAtom = atom<PackageDetail | null>(null)
export const packagePaymentListAtom = atom<PackagePaymentList | null>(null)
export const packagePaymentListPagingAtom = atom<PackagePaymentListPaging>({
  currentPageNumber: 1,
  totalPagesNumber: 1,
  pageSize: 10,
  totalCount: 0,
})

export const memberDetailTabAtom = atom<MemberTab | null>(null)

// export const tabNameAtom = atomWithStorage<'Overview' | 'Segment' | 'Address' | 'Consent' | 'Transaction' | 'Engagement' | 'SmsEngagement' | 'PushEngagement' | 'EmailEngagement'>("MemberTab", "Overview");
export const tabNameAtom = atom<
  | 'Overview'
  | 'Segment'
  | 'Address'
  | 'Consent'
  | 'Transaction'
  | 'Engagement'
  | 'SmsEngagement'
  | 'Activities'
  | 'Packages'
  | 'PushEngagement'
  | 'EmailEngagement'
>('Overview')
